<template>
	<ClientOnly>
		<div v-if="isActive" v-bind="$attrs">
			<slot :name="slotNames.active" />
		</div>
		<div v-else v-show="!isActive" v-bind="$attrs">
			<slot :name="slotNames.inactive" />
		</div>
	</ClientOnly>
</template>

<script setup lang="ts">
	interface Props {
		breakpoint?: boolean;

		/** @deprecated Use `breakpoint` instead */
		isDesktop?: any;
	}

	const props = withDefaults(defineProps<Props>(), {
		breakpoint: undefined,
		isDesktop: undefined,
	});

	defineOptions({inheritAttrs: false});

	const slotNames = computed(() => ({
		active: props.breakpoint === undefined ? 'desktop' : 'true',
		inactive: props.breakpoint === undefined ? 'mobile' : 'false',
	}));

	const isActive = computed(() => props.breakpoint ?? props.isDesktop);
</script>
